import React from 'react'
import _ from 'underscore'
import moment from 'moment'
import { Button } from '@/components/ui/button'
import { Popover, PopoverContent, PopoverTrigger } from '@/components/ui/popover'
import Timeago from '../timeago'
import DatetimePicker from '../datetime_picker'

class TaskDue extends React.Component {

  onChange = (value) => {
    if (value == 'now') {
      value = moment().format("YYYY-MM-DD HH:mm")
    }

    this.props.onChange(value)
  }

  render() {
    const moments = [
      {value: 'now', name: 'Now'},
      {value: moment().add(1, 'days').startOf('day').add(8, 'hours').format("YYYY-MM-DD HH:mm"), name: moment().add(1, 'days').format("dddd")},
      {value: moment().add(2, 'days').startOf('day').add(8, 'hours').format("YYYY-MM-DD HH:mm"), name: moment().add(2, 'days').format("dddd")},
      {value: moment().add(3, 'days').startOf('day').add(8, 'hours').format("YYYY-MM-DD HH:mm"), name: moment().add(3, 'days').format("dddd")}
    ]

    return (
      <Popover>
        <PopoverTrigger asChild>
          <button type="button" className="text-[#337ab7] hover:underline">
            <Timeago date={this.props.due_at}/>
          </button>
        </PopoverTrigger>
        <PopoverContent align="end" className="w-auto px-6 py-4">
          <div className="mb-4">
            When should this task be followed up?
          </div>
          <hr/>
          <div className="flex flex-nowrap">
            <DatetimePicker
              onChange={this.onChange}
              value={this.props.due_at || new Date().setMinutes(0)}
              startView={'month'}
            />
            <div className="p-4">
              {_.map(moments, (time) => {
                return (
                  <div key={time.value} className="mb-1">
                    <Button variant="outline" className="w-full" onClick={() => this.onChange(time.value)}>{time.name}</Button>
                  </div>
                )
              })}
            </div>
          </div>
        </PopoverContent>
      </Popover>
    )
  }
}

export default TaskDue
